/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Ouverte
 * 1 = Cloturee
 */
export enum EvacuationStatut {
  Ouverte = 0,
  Cloturee = 1
}
